import React from "react";
import { Tooltip } from "@vibe/core";
import { Info } from "@vibe/icons";
import { Column } from "./table.data.interface";
import UnsharedColumnRow from "./UnsharedColumnRow";
import type { ColumnValueType } from "../../services/monday/monday-query-interface";

interface CurrentBoardColumnsProps {
  columns: Column[];
  itemId: string;
  boardId: number;
  /** Shows an edited value (as monday returned it) and refetches these rows. */
  onValueSaved: (saved: boolean, written?: ColumnValueType) => Promise<unknown> | void;
}

export const CURRENT_BOARD_COLUMNS_ID = "item-view-current-board-columns";

/**
 * The current board's columns that no other connected board has. These are the ones the
 * column mapping modal used to offer at share time; the "+" on each row replaces it.
 */
const CurrentBoardColumns = ({
  columns,
  itemId,
  boardId,
  onValueSaved,
}: CurrentBoardColumnsProps) => {
  if (columns.length === 0) return null;

  return (
    <div id={CURRENT_BOARD_COLUMNS_ID} className="max-w-[640px] mx-auto pt-6">
      <div className="flex gap-2 items-center mb-3">
        <h3 className="!font-figtree">Only on this board</h3>
        <Tooltip content="These columns aren't on the other boards this item lives on, so their values don't sync. Use + to add one to another board.">
          <div className="flex justify-center items-center cursor-help">
            <Info size={16} color="#676879" />
          </div>
        </Tooltip>
      </div>
      <div className="grid grid-cols-item-view-values-cols gap-x-[2px]">
        {columns.map((column) => (
          <UnsharedColumnRow
            key={column.columnId}
            column={column}
            itemId={itemId}
            editing={{ boardId, onSaved: onValueSaved }}
          />
        ))}
      </div>
    </div>
  );
};

export default CurrentBoardColumns;
